import React, { useEffect, useState } from "react";
import { message, Spin } from "antd";
import ListOrder from "./listOrder";
import Detail from "./detail";
import Service from "./../../utils/apiOpen";
import ICDone from '../../assets/images/success.png';
import Arrows from '../../assets/images/arrow-chevron-left.png';
import Helper from './../../utils/helper';
export const LocalState = React.createContext();

const Index = () => {
    const [step, setStep] = useState(1);
    const [config, setConfig] = useState(false);
    const [detailOrder, setDetailOrder] = useState({});
    const StatusWidget = ({ statusId }) => {
        if(!statusId) return;
        const objColor = {
            'Active': {
                color: "#069D27",
                text: "Đang hoạt động",
            },
            'Pending_Lock_Approval': {
                color: "#E8B602",
                text: "Chờ duyệt",
            },
            'InActive': {
                color: "#343A40",
                text: "Ngừng hoạt động",
            },
        };

        const { color, text } = objColor?.[statusId];
        return (
            <div
                style={{ color: color, display: "flex", alignItems: "center", gap: 5 }}
            >
                <div
                    style={{
                        height: 10,
                        width: 10,
                        background: color,
                        borderRadius: "50%",
                    }}
                ></div>
                {text}
            </div>
        );
    };

    useEffect(() => {
        let dataDetailOrderAff = JSON.parse(localStorage.getItem('dataDetailOrderAff'));
        window.scrollTo(0, 0);
        getConfig();
        if ((Helper.getParamUrlByKey('orderCode') && dataDetailOrderAff?.orderCode)) {
            goStep(2);
            setDetailOrder(dataDetailOrderAff);
        }
    }, []);

    const getConfig = () => {
        Service.openApiCall('GET', `/v1/affiliate/portal/orders/config`)
            .then((res) => {
                if (res.data.success) {
                    setConfig(res?.data?.data);
                }
            })
            .catch((err) => {
                if (err?.response) {
                    message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
                }
            });
    };

    const goStep = (page) => {
        setStep(page);
    };

    const PageView = () => {
        switch (step) {
            case 1:
                return <ListOrder />;
            case 2:
                return <Detail />;
        }
    };

    // Thông báo lỗi dủng chung cho các page
    const MessageErr = (content) => {
        message.error(
            {
                content: content,
                style: {
                    marginTop: "25px",
                },
            },
            15
        );
    };

    const MessageSucces = (content) => {
        message.success(
            {
                icon: <img
                    src={ICDone}
                    width="30"
                    style={{ marginRight: 5 }}
                />,
                content: <div><b>{content}</b></div>,
                style: {
                    marginTop: "25px",
                },
            },
            2
        );
    };

    return (
        <LocalState.Provider
            value={{
                goStep,
                step,
                MessageErr,
                MessageSucces,
                config,
                detailOrder,
                setDetailOrder,
                StatusWidget
            }}
        >
            <div style={{ margin: "0px 5px" }}>{PageView()}</div>
        </LocalState.Provider>
    );
};

export default Index;
